import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';

import { NoteActions } from '@recruitee/notes-data';

@Injectable()
export class RequisitionNotesResolver {
  constructor(private store: Store) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const id = route.parent?.params.id;
    this.store.dispatch(NoteActions.fetchRequisitionNotes({ payload: { requisitionId: id } }));
    return true;
  }
}
